// Constants
import { SERVICE_DOMAINS } from '../constants/services';

// Utilities
import { request } from '../utilities/http';

// Services
export interface IGetStatisticsRequest {
    params: { networkId: string };
    query: { tagId: string, filterTagIds: string };
}
export interface IGetStatisticsResponse {
    tagId: string;
    name: string;
    people: number;
}
export function getStatistics({ params, query }: IGetStatisticsRequest): Promise<IGetStatisticsResponse[]> {
    return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/statistics.people`, {
        method: 'GET',
        query: {
            tagId: query.tagId,
            'filter-tag-ids': query.filterTagIds
        }
    });
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/statistic.ts